import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import CadastroSeguro from './CadastroSeguro';

const Cadastro = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (nome, email, senha, confirmarSenha) => {
    console.log('[CADASTRO] Submit started');
    setErrorMessage(null);

    // Validações
    if (senha !== confirmarSenha) {
      const msg = 'As senhas não coincidem';
      setErrorMessage(msg);
      toast.error(msg);
      return;
    }

    if (senha.length < 6) {
      const msg = 'A senha deve ter no mínimo 6 caracteres';
      setErrorMessage(msg);
      toast.error(msg);
      return;
    }

    setLoading(true);

    try {
      console.log('[CADASTRO] Calling register...');
      await register(nome, email, senha);
      console.log('[CADASTRO] Register successful');
      toast.success('Cadastro realizado! Aguardando aprovação do administrador.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) {
      console.error('[CADASTRO] Error caught:', error);
      const message = error.response?.data?.detail || 'Erro ao fazer cadastro';
      setErrorMessage(message);
      toast.error(message);
    } finally {
      console.log('[CADASTRO] Finally block - setting loading to false');
      setLoading(false);
    }
  };

  return (
    <CadastroSeguro
      onSubmitRegister={handleRegister}
      loading={loading}
      errorMessage={errorMessage}
      logoSrc="/logo.png"
    />
  );
};

export default Cadastro;